import { cva } from 'class-variance-authority';

export const modalTabsClasses = cva(
  [
    'text-sm',
    'h-auto',
    'py-2',
    'px-3',
    'cursor-pointer',
    '[&:not(:last-child)]:border-r',
    'border-info-300',
    'whitespace-nowrap',
    'overflow-hidden',
    'max-w-[300px]',
    'hover:bg-info-100',
    'select-none',
    'flex',
    'gap-2',
    'w-fit',
    'min-w-[80px]',
  ],
  {
    variants: {
      isTabOpen: {
        true: ['bg-primary-100!', 'shrink-0'],
        false: ['shrink'],
      },
      isSelected: {
        true: [],
        false: [],
      },
    },
  },
);
